import DefaultWidgetTemplate from '../DefaultWidgetTemplate';

export default function AdvancedSearchDefaultWidget({ module }) {
  return (
    <DefaultWidgetTemplate
      module={module}
      route="user_module_advancedSearch_home"
    />
  );
}
